import { MouseEventHandler } from 'react'

import { Box, Flex, IconButton, styled } from '@grupoboticario/flora-react'
import { ChevronLeftIcon, ChevronRightIcon } from '@grupoboticario/flora-react-icons'

export interface NavigationButtonProps {
  onClick?: MouseEventHandler<HTMLButtonElement>
  disabled: boolean
}

const iconSize = 42

const NavigationButtonBar = styled(Box, {
  boxSizing: 'border-box',
  display: 'flex',
  placeItems: 'center',
  padding: '0 $2',
})

const NavigationButton = styled(IconButton, {
  padding: 0,
  color: '#000',
  variants: {
    variant: {
      unstyled: {
        '&:disabled': {
          background: 'transparent',
        },
      },
    },
  },
})

export const BackButton = ({ onClick, disabled }: NavigationButtonProps) => (
  <NavigationButtonBar>
    <NavigationButton
      aria-label="Voltar páginas"
      autotagging-flora="on"
      data-flora="button"
      data-flora-text="Voltar páginas"
      data-autotagging-flora-section="catalogo"
      disabled={disabled}
      icon={<ChevronLeftIcon size={iconSize} />}
      onClick={onClick}
      size="large"
      title="Voltar páginas"
      variant="unstyled"
    />
  </NavigationButtonBar>
)

export const NextButton = ({ onClick, disabled }: NavigationButtonProps) => (
  <NavigationButtonBar>
    <NavigationButton
      aria-label="Avançar páginas"
      autotagging-flora="on"
      data-flora="button"
      data-flora-text="Avançar páginas"
      data-autotagging-flora-section="catalogo"
      disabled={disabled}
      icon={<ChevronRightIcon size={iconSize} />}
      onClick={onClick}
      size="large"
      title="Avançar páginas"
      variant="unstyled"
    />
  </NavigationButtonBar>
)

export const Wrapper = styled(Flex, {
  height: '100%',
  width: '100%',
  maxHeight: '100%',
})

export const SliderWrapper = styled(Box, {
  height: '100%',
  overflow: 'hidden',
})
